import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_PPMU_DAY_ZERO = defineFcm('revenue_ppmu_day_zero')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experiment_name: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'PPMU',
		description: 'This FCM config controls the PPMU trial end date set to zero experiment.',
		template: {
			enabled: false,
			experiment_name: 'revenue_ppmu_day_zero',
		},
	});
